import { LOGO_URL } from '@/config/links'
import { useLanguage } from '@/context/LanguageContext'
import { useEffect, useState } from 'react'

function Navbar() {
  const { lang, toggleLang } = useLanguage()
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 12)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollHome = () => {
    document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-[#3d2b1f]/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-md mx-auto px-4 h-14 flex items-center justify-between">
        <button
          type="button"
          onClick={scrollHome}
          className="flex items-center gap-2 text-amber-50 font-semibold text-sm tracking-wide"
        >
          <img src={LOGO_URL} alt="Vitrine The Mimi Factory" className="w-10 h-10 object-contain" />
          The Mimi Factory
        </button>

        <button
          type="button"
          onClick={toggleLang}
          className="text-xs font-semibold px-3 py-1.5 rounded-full border border-amber-400/40 text-amber-300 hover:bg-amber-400/10 transition-colors"
        >
          {lang === 'fr' ? 'EN' : 'FR'}
        </button>
      </div>
    </header>
  )
}

export default Navbar
